export enum ApronStatus {
  // --- Shift Start Workflow ---
  START_SHIFT_REQUESTED = 'start-shift requested',
  START_SHIFT_PENDING = 'start-shift pending',
  START_SHIFT_APPROVED = 'start-shift approved',
  START_SHIFT_REJECTED = 'start-shift rejected',
  START_SHIFT_ACKNOWLEDGED = 'start-shift acknowledged',

  // --- Cash Drop Workflow ---
  CASH_DROP_REQUESTED = 'cash-drop requested',
  CASH_DROP_PENDING = 'cash-drop pending',
  CASH_DROP_APPROVED = 'cash-drop approved',
  CASH_DROP_REJECTED = 'cash-drop rejected',
  CASH_DROP_ACKNOWLEDGED = 'cash-drop acknowledged',

  // --- Shift End Workflow ---
  END_SHIFT_REQUESTED = 'end-shift requested',
  END_SHIFT_PENDING = 'end-shift pending',
  END_SHIFT_APPROVED = 'end-shift approved',
  END_SHIFT_REJECTED = 'end-shift rejected',
  END_SHIFT_ACKNOWLEDGED = 'end-shift acknowledged',
}
